import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchJobsList = createAsyncThunk(
  "fetchJobsList",
  async ({ page, limit, filters }) => {
    const token = localStorage.getItem("auth_token");

    const keyword = filters?.keyword ? filters?.keyword : "";

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    const response = await axiosHttp.get(
      `job/list?page=${page}&limit=${limit}`,
      config
    );

    return response.data.data;
  }
);

const JobsListSlice = createSlice({
  name: "JobsList",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
    page: 1,
    total: 0,
  },

  extraReducers: (builder) => {
    builder.addCase(fetchJobsList.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(fetchJobsList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.page = action.payload.page;
      state.total = action.payload.total;
    });
    builder.addCase(fetchJobsList.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default JobsListSlice.reducer;
